import React from 'react';
import "bootstrap/dist/css/bootstrap.css";

class Loader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            message: ""
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.loaded !== this.props.loaded || prevProps.message !== this.props.message) {            
            this.setState({
                loaded: this.props.loaded,
                message: this.props.message
            });
        }
    }

    render() {
        return (
            <div className="text-center">
                {
                    this.state.message
                        ?
                        <div className="alert alert-warning" role="alert">
                            {this.state.message}
                        </div>
                        :
                        <div></div>
                }
                {
                    this.state.loaded
                        ?
                        <div>
                        </div>
                        :
                        <div className="text-center">
                            <div className="spinner-border text-secondary" role="status">
                            </div>
                            <p className = "mt-1">Пожалуйста, подождите...</p>
                        </div>
                }
            </div>
        );
    }
}

export default Loader;